module.exports = __webpack_public_path__ + "static/55-767be2f45e1b31a3edd976e13689040f.jpg";